import "./Links.css";

import { RiLockPasswordFill } from "react-icons/ri";
import { AiOutlineMail } from "react-icons/ai";
import { BsChatDots, BsCardChecklist } from "react-icons/bs";
import { MdOutlineContactPhone, MdExtension } from "react-icons/md";
import { SiJirasoftware, SiStatuspal } from "react-icons/si";
import { FiExternalLink } from "react-icons/fi";

import { Joyride } from "react-joyride";

import ProfileSubHeaderLinks from "../../components/profileSubHeaderLinks/ProfileSubHeaderLinks.jsx";
import { useOnboarding } from "../../context/onboardingContext.jsx";

const links = [
  {
    title: "LMS Systems",
    description: "Training and learning platform",
    url: "https://moodle-lms.sirius-support.com/login",
    icon: BsCardChecklist,
    className: "lms",
  },
  {
    title: "QuinnDesk",
    description: "Customer support and communication",
    url: "https://quinndesk.sirius-support.com/",
    icon: MdOutlineContactPhone,
    className: "quinndesk",
  },
  {
    title: "Internal Chat",
    description: "Communicate with your team",
    url: "https://chat.sirius-support.com/",
    icon: BsChatDots,
    className: "chat",
  },
  {
    title: "Password Manager",
    description: "Access and manage your passwords",
    url: "https://vault.sirius-support.com/",
    icon: RiLockPasswordFill,
    className: "vault",
  },
  {
    title: "Sirius Email",
    description: "Access your Sirius email account",
    url: "https://webmail.sirius-support.io/",
    icon: AiOutlineMail,
    className: "email",
  },
  {
    title: "Jira Portal",
    description: "Report system bugs and issues",
    url: "https://sirius-support.atlassian.net/servicedesk/customer/portals",
    icon: SiJirasoftware,
    className: "jira",
  },
  {
    title: "Systems Status",
    description: "Check the current status of Sirius systems",
    url: "https://kuma.sirius-support.com/status/siriussystems",
    icon: SiStatuspal,
    className: "status",
  },
  {
    title: "Minerva Extension",
    description: "Install the Minerva browser extension",
    url: "https://chromewebstore.google.com/detail/minerva/kkjjhhjnadbccngfkapjeakggbjkibph",
    icon: MdExtension,
    className: "minerva",
  },
];

/**
 * @function Links
 * @returns {JSX.Element} - Work information and useful links page.
 */
function Links() {
  const { runTour, goToNextPage } = useOnboarding();

  const steps = [
    {
      target: "body",
      placement: "center",
      content:
        "Here you can find links to the most commonly used systems within our organization. From a chat tool to our training platform. We have it all!",
      title: "Links page",
      disableBeacon: true,
    },
    {
      target: "#step-links",
      title: "Useful links",
      content:
        "As part of your onboarding, please go to the LMS Systems link and complete the InfoSec training.",
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { action, index, type } = data;

    if (
      type === "step:after" &&
      action === "next" &&
      index === steps.length - 1
    ) {
      goToNextPage();
    }
  };

  return (
    <div className="profileMain">
      <ProfileSubHeaderLinks />

      <div className="employee-main">
        <Joyride
          steps={steps}
          run={runTour}
          continuous
          showSkipButton
          showProgress
          scrollToFirstStep
          callback={handleJoyrideCallback}
          locale={{
            next: "Next",
            last: "Next Page",
            skip: "Skip tour",
            back: "Back",
          }}
          styles={{
            options: {
              primaryColor: "#0BADDE",
              zIndex: 10000,
            },
            tooltip: {
              borderRadius: "8px",
            },
            buttonNext: {
              backgroundColor: "#0BADDE",
            },
          }}
        />

        <div className="employee-main-work-info links-page">
          <div className="links-header">
            <div>
              <h1 className="user-requests-header">Links</h1>

              <p className="links-subtitle">
                Quick access to the tools and systems you use every day.
              </p>
            </div>
          </div>

          <div id="step-links" className="links-grid">
            {links.map((link) => {
              const Icon = link.icon;

              return (
                <a
                  key={link.title}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`link-card ${link.className}`}
                >
                  <div className="link-card-icon">
                    <Icon />
                  </div>

                  <div className="link-card-content">
                    <div className="link-card-title-row">
                      <h3>{link.title}</h3>

                      <FiExternalLink className="external-link-icon" />
                    </div>

                    <p>{link.description}</p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Links;